function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { sql } from "./dependencies.js";
import { requireDefault } from "./require.js";
export function SQLite(_x) {
  return _SQLite.apply(this, arguments);
}

function _SQLite() {
  _SQLite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(require) {
    var _yield$Promise$all3, _yield$Promise$all4, init, dist;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return Promise.all([require(sql.resolve()), require.resolve(sql.resolve("dist/"))]);

          case 2:
            _yield$Promise$all3 = _context9.sent;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            init = _yield$Promise$all4[0];
            dist = _yield$Promise$all4[1];
            return _context9.abrupt("return", init({
              locateFile: function locateFile(file) {
                return "".concat(dist).concat(file);
              }
            }));

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _SQLite.apply(this, arguments);
}

export var SQLiteDatabaseClient = /*#__PURE__*/function () {
  function SQLiteDatabaseClient(db) {
    _classCallCheck(this, SQLiteDatabaseClient);

    Object.defineProperties(this, {
      _db: {
        value: db
      }
    });
  }

  _createClass(SQLiteDatabaseClient, [{
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_query, params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return exec(this._db, _query, params);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function query(_x2, _x3) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }, {
    key: "queryRow",
    value: function () {
      var _queryRow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.query(query, params);

              case 2:
                _context2.t0 = _context2.sent[0];

                if (_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.t0 = null;

              case 5:
                return _context2.abrupt("return", _context2.t0);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function queryRow(_x4, _x5) {
        return _queryRow.apply(this, arguments);
      }

      return queryRow;
    }()
  }, {
    key: "explain",
    value: function () {
      var _explain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query, params) {
        var rows;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.query("EXPLAIN QUERY PLAN ".concat(query), params);

              case 2:
                rows = _context3.sent;
                return _context3.abrupt("return", element("pre", {
                  className: "observablehq--inspect"
                }, [text(rows.map(function (row) {
                  return row.detail;
                }).join("\n"))]));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function explain(_x6, _x7) {
        return _explain.apply(this, arguments);
      }

      return explain;
    }()
  }, {
    key: "describeTables",
    value: function () {
      var _describeTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _ref,
            schema,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, schema = _ref.schema;
                return _context4.abrupt("return", this.query("SELECT NULLIF(schema, 'main') AS schema, name FROM pragma_table_list() WHERE type = 'table'".concat(schema == null ? "" : " AND schema = ?", " AND name NOT LIKE 'sqlite_%' ORDER BY schema, name"), schema == null ? [] : [schema]));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function describeTables() {
        return _describeTables.apply(this, arguments);
      }

      return describeTables;
    }()
  }, {
    key: "describeColumns",
    value: function () {
      var _describeColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _ref2,
            schema,
            table,
            rows,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref2 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, schema = _ref2.schema, table = _ref2.table;

                if (!(table == null)) {
                  _context5.next = 3;
                  break;
                }

                throw new Error("missing table");

              case 3:
                _context5.next = 5;
                return this.query("SELECT name, type, \"notnull\" FROM pragma_table_info(?".concat(schema == null ? "" : ", ?", ") ORDER BY cid"), schema == null ? [table] : [table, schema]);

              case 5:
                rows = _context5.sent;

                if (rows.length) {
                  _context5.next = 8;
                  break;
                }

                throw new Error("table not found: ".concat(table));

              case 8:
                return _context5.abrupt("return", rows.map(function (_ref3) {
                  var name = _ref3.name,
                      type = _ref3.type,
                      notnull = _ref3.notnull;
                  return {
                    name: name,
                    type: sqliteType(type),
                    databaseType: type,
                    nullable: !notnull
                  };
                }));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function describeColumns() {
        return _describeColumns.apply(this, arguments);
      }

      return describeColumns;
    }()
  }, {
    key: "describe",
    value: function () {
      var _describe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(object) {
        var rows, columns;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return object === undefined ? this.query("SELECT name FROM sqlite_master WHERE type = 'table'") : this.query("SELECT * FROM pragma_table_info(?)", [object]);

              case 2:
                rows = _context6.sent;

                if (rows.length) {
                  _context6.next = 5;
                  break;
                }

                throw new Error("Not found");

              case 5:
                columns = rows.columns;
                return _context6.abrupt("return", element("table", {
                  value: rows
                }, [element("thead", [element("tr", columns.map(function (c) {
                  return element("th", [text(c)]);
                }))]), element("tbody", rows.map(function (r) {
                  return element("tr", columns.map(function (c) {
                    return element("td", [text(r[c])]);
                  }));
                }))]));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function describe(_x8) {
        return _describe.apply(this, arguments);
      }

      return describe;
    }()
  }, {
    key: "sql",
    value: function () {
      var _sql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.query.apply(this, _toConsumableArray(this.queryTag.apply(this, _args7))));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sql() {
        return _sql.apply(this, arguments);
      }

      return sql;
    }()
  }, {
    key: "queryTag",
    value: function queryTag(strings) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      return [strings.join("?"), params];
    }
  }], [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(source) {
        var _yield$Promise$all, _yield$Promise$all2, SQL, buffer;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Promise.all([SQLite(requireDefault), Promise.resolve(source).then(load)]);

              case 2:
                _yield$Promise$all = _context8.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                SQL = _yield$Promise$all2[0];
                buffer = _yield$Promise$all2[1];
                return _context8.abrupt("return", new SQLiteDatabaseClient(new SQL.Database(buffer)));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function open(_x9) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }]);

  return SQLiteDatabaseClient;
}();
Object.defineProperty(SQLiteDatabaseClient.prototype, "dialect", {
  value: "sqlite"
}); // https://www.sqlite.org/datatype3.html

function sqliteType(type) {
  switch (type) {
    case "NULL":
      return "null";

    case "INT":
    case "INTEGER":
    case "TINYINT":
    case "SMALLINT":
    case "MEDIUMINT":
    case "BIGINT":
    case "UNSIGNED BIG INT":
    case "INT2":
    case "INT8":
      return "integer";

    case "TEXT":
    case "CLOB":
      return "string";

    case "REAL":
    case "DOUBLE":
    case "DOUBLE PRECISION":
    case "FLOAT":
    case "NUMERIC":
      return "number";

    case "BLOB":
      return "buffer";

    case "DATE":
    case "DATETIME":
      return "string";
    // TODO convert strings to Date instances in sql.js

    default:
      return /^(?:(?:(?:VARYING|NATIVE) )?CHARACTER|(?:N|VAR|NVAR)CHAR)\(/.test(type) ? "string" : /^(?:DECIMAL|NUMERIC)\(/.test(type) ? "number" : "other";
  }
}

function load(source) {
  return typeof source === "string" ? fetch(source).then(load) : source instanceof Response || source instanceof Blob ? source.arrayBuffer().then(load) : source instanceof ArrayBuffer ? new Uint8Array(source) : source;
}

function exec(_x10, _x11, _x12) {
  return _exec.apply(this, arguments);
}

function _exec() {
  _exec = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(db, query, params) {
    var _yield$db$exec, _yield$db$exec2, result, columns, values, rows;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return db.exec(query, params);

          case 2:
            _yield$db$exec = _context10.sent;
            _yield$db$exec2 = _slicedToArray(_yield$db$exec, 1);
            result = _yield$db$exec2[0];

            if (result) {
              _context10.next = 7;
              break;
            }

            return _context10.abrupt("return", []);

          case 7:
            columns = result.columns, values = result.values;
            rows = values.map(function (row) {
              return Object.fromEntries(row.map(function (value, i) {
                return [columns[i], value];
              }));
            });
            rows.columns = columns;
            return _context10.abrupt("return", rows);

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _exec.apply(this, arguments);
}

function element(name, props, children) {
  if (arguments.length === 2) children = props, props = undefined;
  var element = document.createElement(name);
  if (props !== undefined) for (var p in props) {
    element[p] = props[p];
  }

  if (children !== undefined) {
    var _iterator = _createForOfIteratorHelper(children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var c = _step.value;
        element.appendChild(c);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return element;
}

function text(value) {
  return document.createTextNode(value);
}